import RegionalSidebar from "./RegionalSidebar";

export default function RegionalLayout({ children }) {
  return (
    <div className="flex h-screen overflow-hidden" style={{ background: "var(--bg-app, #f0f2f5)" }}>
      <RegionalSidebar />
      <main className="flex-1 overflow-y-auto p-6">
        {children}
      </main>
    </div>
  );
}
